import { AGENT_RAIL_PX, EGO_RAIL_PX } from "../neucleos/agentRailFold";

export const AGENT_RAIL_WIDTH_STORAGE_KEY = "cleo:agent-rail-width";
// The Cockpit desk furniture contract for an agent rail column, READ from
// the donor allocator (CLEO-CAN FD02: one source for the numbers, never a
// re-declared literal). One width serves every NESTED rail at every depth —
// per-rail widths would fork the single allocator the fold law requires.
// The root session rail (level 0, Cleo's) is the one lawful exception: it is its own
// furniture term in the donor allocator, so it carries its own width.
export const AGENT_RAIL_DEFAULT_WIDTH = AGENT_RAIL_PX;
// The old `clamp(15rem,18vw,20rem)` floor; a rail's composer stops being
// usable below it.
export const AGENT_RAIL_MIN_WIDTH = 240;
export const AGENT_RAIL_MAX_WIDTH = 400;
// The person's open-rail cap is a door fact like the widths: per device,
// never part of any World's remembered room.
export const AGENT_RAIL_CAP_STORAGE_KEY = "cleo:agent-rail-cap";

// Cleo's root session rail (level 0): its own width preference, defaulted from the
// donor's own ego term (principal ruling 2026-08-26 — the leftmost rail is
// different furniture from the nested chain and never folds).
export const PRIMARY_AGENT_RAIL_WIDTH_STORAGE_KEY = "cleo:root-session-rail-width";
export const PRIMARY_AGENT_RAIL_DEFAULT_WIDTH = EGO_RAIL_PX;
export const PRIMARY_AGENT_RAIL_MIN_WIDTH = 240;
/**
 * DATED REVISION 2026-10-07 (Widen Cleo; the principal: "ideally, twice as
 * wide", then "I agree with your recommendation"): Cleo's width is two parts.
 * Up to the old 480 ceiling it is fixed furniture, as before: it never folds
 * and the context law reserves it. Above that it is a wish that takes only
 * the deck's free space, so a drag never folds another panel and a stored
 * 960 on a smaller window settles back instead of squeezing the deck. The
 * drag ceiling is twice the old one; Widen Cleo asks for the same width and
 * is the one act that may fold the context rail and the dock to get it.
 */
export const PRIMARY_AGENT_RAIL_FIXED_WIDTH = 480;
export const PRIMARY_AGENT_RAIL_MAX_WIDTH = 960;
export const PRIMARY_AGENT_RAIL_WIDE_WIDTH = PRIMARY_AGENT_RAIL_MAX_WIDTH;
